import Vue, { PluginObject } from 'vue';

const _formatPrice = (price: number, currency: string) => {
  return `${price.toFixed(2)} ${currency}`;
}

const Plugin: PluginObject<any> = {
  install: (Vue) => {
    Vue.$formatPrice = _formatPrice;
  },
};
Plugin.install = (Vue) => {
  Vue.$formatPrice = _formatPrice;
  Object.defineProperties(Vue.prototype, {
    $formatPrice: {
      get() {
        return _formatPrice;
      },
    },
  });
};

Vue.use(Plugin);

export default Plugin;
